(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[711],{

/***/ 63789:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ LayoutWrapper; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14517);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67268);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58048);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52983);





function LayoutWrapper(param) {
    let { title , children , className  } = param;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: title ? "".concat(title, "・Chirpy") : "Chirpy"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "canonical",
                        href: "https://chirpy.dev".concat(router.asPath)
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("flex min-h-full flex-col font-sans text-gray-1100", className),
                children: children
            })
        ]
    });
}


/***/ }),

/***/ 74512:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ SignInButton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var _chirpy_dev_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49595);
/* harmony import */ var next_auth_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60697);
/* harmony import */ var next_auth_react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_auth_react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52983);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(44623);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(71133);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8172);
/* harmony import */ var _contexts_current_user_context__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(38612);
/* harmony import */ var _hooks_use_sign_in_window__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(98880);







const handleSessionAndSignIn = ()=>{
    sessionStorage.setItem(_chirpy_dev_utils__WEBPACK_IMPORTED_MODULE_3__/* .CALLBACK_URL_KEY */ .KN, location.pathname);
    (0,next_auth_react__WEBPACK_IMPORTED_MODULE_1__.signIn)();
};
function SignInButton(param) {
    let { variant ="solid" , inPageNav , ...restProps } = param;
    const { loading: signInLoading  } = (0,_contexts_current_user_context__WEBPACK_IMPORTED_MODULE_4__/* .useCurrentUser */ .x)();
    const handleSignIn = (0,_hooks_use_sign_in_window__WEBPACK_IMPORTED_MODULE_5__/* .useSignInWindow */ .u)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_6__/* .Button */ .z, {
        color: "primary",
        variant: variant,
        onClick: ()=>!inPageNav ? handleSignIn() : handleSessionAndSignIn(),
        ...restProps,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
            className: "inline-flex flex-row items-center space-x-1",
            children: [
                signInLoading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    "aria-label": "Signing in",
                    className: "h-5 w-5 animate-spin"
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    size: "14"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    children: "Sign in"
                })
            ]
        })
    });
}


/***/ }),

/***/ 76142:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ UserMenu; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var _chirpy_dev_utils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(49595);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(14517);
/* harmony import */ var next_auth_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60697);
/* harmony import */ var next_auth_react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_auth_react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52983);
/* harmony import */ var _components_avatar__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(71720);
/* harmony import */ var _components_icons__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(60542);
/* harmony import */ var _components_icons__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(83850);
/* harmony import */ var _components_icons__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(21317);
/* harmony import */ var _components_icons__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(32159);
/* harmony import */ var _components_icons__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(78674);
/* harmony import */ var _components_link__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(46853);
/* harmony import */ var _components_menu__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(13570);
/* harmony import */ var _components_text__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(28767);
/* harmony import */ var _contexts_current_user_context__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38612);
/* harmony import */ var _hooks_use_sign_in_window__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98880);












function UserMenu(props) {
    const { isSignIn , data  } = (0,_contexts_current_user_context__WEBPACK_IMPORTED_MODULE_3__/* .useCurrentUser */ .x)();
    const { image , name , email , username  } = data;
    const handleSignIn = (0,_hooks_use_sign_in_window__WEBPACK_IMPORTED_MODULE_4__/* .useSignInWindow */ .u)();
    const isWidget = props.variant === "Widget";
    const isNav = props.variant === "Nav";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_menu__WEBPACK_IMPORTED_MODULE_5__/* .Menu */ .v, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_menu__WEBPACK_IMPORTED_MODULE_5__/* .Menu.Button */ .v.Button, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_avatar__WEBPACK_IMPORTED_MODULE_6__/* .Avatar */ .q, {
                    src: image,
                    alt: "".concat(name || username, "'s avatar"),
                    email: email,
                    name: name,
                    username: username
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_menu__WEBPACK_IMPORTED_MODULE_5__/* .Menu.Items */ .v.Items, {
                className: "",
                children: [
                    name && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "mx-6 py-2",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_text__WEBPACK_IMPORTED_MODULE_7__/* .Text */ .x, {
                                className: "w-36 text-left line-clamp-2",
                                bold: true,
                                children: name
                            }),
                            email && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_text__WEBPACK_IMPORTED_MODULE_7__/* .Text */ .x, {
                                variant: "secondary",
                                className: "w-36 break-words text-left line-clamp-2",
                                size: "sm",
                                children: email
                            })
                        ]
                    }),
                    isSignIn && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_menu__WEBPACK_IMPORTED_MODULE_5__/* .Menu.Divider */ .v.Divider, {}),
                    isWidget && (isSignIn ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_menu__WEBPACK_IMPORTED_MODULE_5__/* .Menu.Item */ .v.Item, {
                        className: itemStyle,
                        onClick: handleSignIn,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_icons__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                size: 14
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "w-max",
                                children: "Sign in"
                            })
                        ]
                    })),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_menu__WEBPACK_IMPORTED_MODULE_5__/* .Menu.Item */ .v.Item, {
                        as: MenuLink,
                        variant: "plain",
                        target: "_blank",
                        href: _chirpy_dev_utils__WEBPACK_IMPORTED_MODULE_9__/* .FEEDBACK_LINK */ .o9,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_icons__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                size: 14
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: "Feedback"
                            })
                        ]
                    }),
                    isSignIn && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            isNav && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_menu__WEBPACK_IMPORTED_MODULE_5__/* .Menu.Item */ .v.Item, {
                                as: MenuLink,
                                variant: "plain",
                                href: "/dashboard",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_icons__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                        size: 14
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        children: "Dashboard"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_menu__WEBPACK_IMPORTED_MODULE_5__/* .Menu.Item */ .v.Item, {
                                as: MenuLink,
                                variant: "plain",
                                href: "/profile",
                                target: isWidget ? "_blank" : undefined,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_icons__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                        size: 14
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        children: "Profile"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_menu__WEBPACK_IMPORTED_MODULE_5__/* .Menu.Divider */ .v.Divider, {}),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_menu__WEBPACK_IMPORTED_MODULE_5__/* .Menu.Item */ .v.Item, {
                                className: itemStyle,
                                onClick: async ()=>{
                                    await (0,next_auth_react__WEBPACK_IMPORTED_MODULE_1__.signOut)({
                                        redirect: !isWidget
                                    });
                                    localStorage.removeItem(_chirpy_dev_utils__WEBPACK_IMPORTED_MODULE_9__/* .SIGN_IN_SUCCESS_KEY */ .CZ);
                                    indexedDB.deleteDatabase(_chirpy_dev_utils__WEBPACK_IMPORTED_MODULE_9__/* .GRAPHQL_CACHE_DB_NAME */ .m2);
                                },
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_icons__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                        size: 14
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "w-max",
                                        children: "Log out"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
const MenuLink = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.forwardRef(function MenuLink(param, ref) {
    let { className , ...restProps } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_link__WEBPACK_IMPORTED_MODULE_14__/* .Link */ .r, {
        ref: ref,
        ...restProps,
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(itemStyle, className)
    });
});
const itemStyle = "justify-start space-x-1";


/***/ }),

/***/ 93383:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ easeInOutOpacity; },
/* harmony export */   "m": function() { return /* binding */ easeInOut; }
/* harmony export */ });
const easeInOut = {
    transition: {
        duration: 0.15
    },
    initial: {
        opacity: 0.5,
        scale: 0.95
    },
    animate: {
        opacity: 1,
        scale: 1
    },
    exit: {
        opacity: 0.5,
        scale: 0.95
    }
};
const easeInOutOpacity = {
    transition: {
        duration: 0.15
    },
    initial: {
        opacity: 0
    },
    animate: {
        opacity: 1
    },
    exit: {
        opacity: 0
    }
};


/***/ }),

/***/ 71720:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "q": function() { return /* binding */ Avatar; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@1.2.1/node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(14517);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@geist-ui+icons@1.0.2_react@18.2.0/node_modules/@geist-ui/icons/user.js
var user = __webpack_require__(32159);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next@13.0.2_biqbaboplfbrettd7655fr4n2y/node_modules/next/dynamic.js
var dynamic = __webpack_require__(14576);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ../../packages/ui/src/components/avatar/custom-avatar.tsx



const LazyAvvvatar = dynamic_default()(()=>__webpack_require__.e(/* import() | custom-avatar */ 186).then(__webpack_require__.bind(__webpack_require__, 17955)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(17955)
            ]
    },
    suspense: true
});
function DeferredCustomAvatar(param) {
    let { fallback , className , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
        fallback: fallback,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: className,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyAvvvatar, {
                ...props,
                style: props.style || (props.value.split("@")[0][1].toLowerCase() > "n" ? "character" : "shape")
            })
        })
    });
}

;// CONCATENATED MODULE: ../../packages/ui/src/components/avatar/avatar.tsx





const sizeStyles = {
    sm: [
        "w-4 h-4",
        20
    ],
    md: [
        "w-8 h-8",
        32
    ],
    lg: [
        "w-12 h-12",
        48
    ],
    xl: [
        "w-16 h-16",
        64
    ]
};
function Avatar(param) {
    let { size ="md" , className , alt , children , src , email , name , username , ...imgProps } = param;
    alt || (alt = "Default avatar");
    const [sizeStyle, iconSize] = sizeStyles[size];
    if (!src) {
        const placeholder = /*#__PURE__*/ (0,jsx_runtime.jsx)(user/* default */.Z, {
            size: iconSize * 0.75,
            className: (0,clsx_m/* default */.Z)("m-1 rounded-full", ring, className),
            "aria-label": alt
        });
        // Keep this order to reduce name collision
        const customAvatarValue = username || email || name;
        if (customAvatarValue) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(DeferredCustomAvatar, {
                value: customAvatarValue,
                fallback: placeholder,
                size: iconSize,
                border: true,
                className: (0,clsx_m/* default */.Z)(className)
            });
        }
        return placeholder;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
        ...imgProps,
        src: src,
        alt: alt,
        className: (0,clsx_m/* default */.Z)(bg, ring, "flex select-none items-center justify-center rounded-full", sizeStyle, className),
        children: children
    });
}
const bg = "bg-grayl-100/60 dark:bg-grayd-100/30";
const ring = "ring ring-white";


/***/ }),

/***/ 19101:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ Badge; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14517);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);



function Badge(param) {
    let { className , children , variant ="default" , color ="primary"  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("rounded p-1 text-xs", variantColorStyles["".concat(variant, "-").concat(color)], className),
        children: children
    });
}
const variantColorStyles = {
    "default-primary": "bg-primary-600 text-primary-1100",
    "default-blue": "bg-blue-600 text-blue-1100",
    "solid-primary": "bg-primary-900 text-white",
    "solid-blue": "bg-blue-900 text-white"
};


/***/ }),

/***/ 45565:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ Divider; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14517);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var _components_text__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28767);
/* harmony import */ var _heading__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21179);
/* harmony import */ var _divider_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15392);
/* harmony import */ var _divider_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_divider_module_scss__WEBPACK_IMPORTED_MODULE_3__);






const WrapperMap = {
    text: DividerText,
    heading: DividerHeading
};
function Divider(param) {
    let { vertical , className , variant , children , ...divProps } = param;
    const _className = vertical ? (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("w-[1px] mx-1", "bg-gray-500") : (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("relative w-auto max-w-full my-1", (_divider_module_scss__WEBPACK_IMPORTED_MODULE_3___default().divider));
    if (!children) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            role: "separator",
            ...divProps,
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_className, className)
        });
    }
    if (!variant) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            role: "separator",
            ...divProps,
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_className, className),
            children: children
        });
    }
    const Wrapper = variant ? WrapperMap[variant] : react__WEBPACK_IMPORTED_MODULE_1__.Fragment;
    const rootClassName = (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("flex flex-row items-center", className);
    const lineClassName = (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_className, "!w-full");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        role: "separator",
        className: rootClassName,
        ...divProps,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: lineClassName
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Wrapper, {
                children: children
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: lineClassName
            })
        ]
    });
}
function DividerText(param) {
    let { children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_text__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .x, {
        as: "span",
        variant: "secondary",
        className: "px-2",
        size: "sm",
        children: children
    });
}
function DividerHeading(param) {
    let { children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heading__WEBPACK_IMPORTED_MODULE_5__/* .Heading */ .X, {
        className: "px-2",
        children: children
    });
}


/***/ }),

/***/ 46853:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ Link; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14517);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(62239);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12166);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58048);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52983);
/* harmony import */ var _hooks_use_has_mounted__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(60175);







const sizeStyles = {
    xs: "text-xs",
    sm: "text-sm",
    md: "text-base",
    lg: "text-lg"
};
const variantStyles = {
    primary: "text-gray-1200 whitespace-nowrap",
    secondary: "text-gray-1100",
    plain: "",
    solid: "text-blue-1100 hover:text-blue-1200"
};
/* eslint-disable jsx-a11y/anchor-is-valid */ const Link = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_3__.forwardRef(function Link(param, ref) {
    let { size , href , as , replace , target: _target , scroll , shallow , prefetch , highlightPattern , hideUnderline , variant ="primary" , className , children , disabled , ...restProps } = param;
    if (disabled) {
        href = "";
    }
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const mounted = (0,_hooks_use_has_mounted__WEBPACK_IMPORTED_MODULE_4__/* .useHasMounted */ .f)();
    // highlight only apply on client
    const highlight = mounted && (highlightPattern === null || highlightPattern === void 0 ? void 0 : highlightPattern.test(router.asPath));
    const [isHovering, setIsHovering] = react__WEBPACK_IMPORTED_MODULE_3__.useState(false);
    const [target, setTarget] = react__WEBPACK_IMPORTED_MODULE_3__.useState(_target || "_self");
    react__WEBPACK_IMPORTED_MODULE_3__.useEffect(()=>{
        if (!_target && href.startsWith("http") && !href.startsWith(window.location.origin)) {
            setTarget("_blank");
        }
    }, [
        _target,
        href
    ]);
    const commonProps = {
        target,
        ...target === "_blank" && {
            rel: "noopener noreferrer"
        },
        href,
        as,
        replace,
        scroll,
        shallow,
        prefetch,
        ...restProps
    };
    const handler = (e)=>{
        if (disabled) {
            e.preventDefault();
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: variant === "plain" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
            ...commonProps,
            onClick: handler,
            ref: ref,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(size && sizeStyles[size], disabled && disabledStyle, className),
                children: children
            })
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
            ...commonProps,
            onMouseEnter: ()=>setIsHovering(true),
            onMouseLeave: ()=>setIsHovering(false),
            onClick: handler,
            ref: ref,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)("relative !no-underline transition duration-150 ease-in-out", size && sizeStyles[size], highlight && "font-bold", variantStyles[variant], disabled && disabledStyle, className),
                children: [
                    children,
                    !hideUnderline && [
                        "primary",
                        "secondary"
                    ].includes(variant) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "absolute bottom-0 left-0 -mb-1 hidden h-0.5 w-full overflow-hidden sm:inline-block",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_6__.m.span, {
                            className: "absolute inset-0 inline-block bg-current",
                            initial: {
                                scale: 0,
                                opacity: 0
                            },
                            animate: {
                                scale: isHovering ? 1 : 0,
                                opacity: isHovering ? 1 : 0
                            },
                            exit: {
                                scale: 0,
                                opacity: 0
                            }
                        })
                    })
                ]
            })
        })
    });
});
const disabledStyle = "hover:cursor-default";


/***/ }),

/***/ 16290:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ Logo; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var _chirpy_dev_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22731);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14517);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var _badge__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19101);
/* harmony import */ var _link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46853);






const sizeWidth = {
    sm: "w-16",
    md: "w-24",
    lg: "w-32"
};
const sizeSpacing = {
    sm: "px-1",
    md: "px-2 py-1",
    lg: "px-3 py-2"
};
function Logo(param) {
    let { size ="md" , hideSpacing , className , linkProps , showBadge  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_link__WEBPACK_IMPORTED_MODULE_2__/* .Link */ .r, {
        href: "/",
        "aria-label": "Logo of Chirpy",
        variant: "plain",
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("relative text-violet-900", className),
        ...linkProps,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LogoBadge, {
                showBadge: showBadge
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(sizeWidth[size], !hideSpacing && sizeSpacing[size]),
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 282 91",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: "currentColor",
                    d: "M34.40 72L34.40 72Q28.20 72 22.80 69.80Q17.40 67.60 13.45 63.30Q9.50 59 7.20 52.70Q4.90 46.40 4.90 38.30L4.90 38.30Q4.90 30.30 7.25 23.95Q9.60 17.60 13.65 13.20Q17.70 8.80 23.15 6.50Q28.60 4.20 34.80 4.20L34.80 4.20Q41 4.20 45.80 6.70Q50.60 9.20 53.70 12.50L53.70 12.50L47.50 20.00Q44.90 17.40 41.90 15.85Q38.90 14.30 35.10 14.30L35.10 14.30Q31.10 14.30 27.75 15.95Q24.40 17.60 21.95 20.65Q19.50 23.70 18.15 28.10Q16.80 32.50 16.80 38.00L16.80 38.00Q16.80 49.20 21.65 55.55Q26.50 61.90 34.80 61.90L34.80 61.90Q39.20 61.90 42.60 60.05Q46 58.20 48.80 55.20L48.80 55.20L55 62.50Q51 67.10 45.85 69.55Q40.70 72 34.40 72ZM76.40 70.80L64.90 70.80L64.90 0.20L76.40 0.20L76.40 18.40L76 27.90Q79.10 25.00 82.85 22.75Q86.60 20.50 91.70 20.50L91.70 20.50Q99.60 20.50 103.20 25.55Q106.80 30.60 106.80 40L106.80 40L106.80 70.80L95.30 70.80L95.30 41.50Q95.30 35.40 93.50 32.90Q91.70 30.40 87.60 30.40L87.60 30.40Q84.40 30.40 81.95 31.95Q79.50 33.50 76.40 36.50L76.40 36.50L76.40 70.80ZM132.20 70.80L120.70 70.80L120.70 21.70L132.20 21.70L132.20 70.80ZM126.50 13.10L126.50 13.10Q123.40 13.10 121.40 11.30Q119.40 9.50 119.40 6.60L119.40 6.60Q119.40 3.70 121.40 1.85Q123.40 0 126.50 0L126.50 0Q129.60 0 131.60 1.85Q133.60 3.70 133.60 6.60L133.60 6.60Q133.60 9.50 131.60 11.30Q129.60 13.10 126.50 13.10ZM158.40 70.80L146.90 70.80L146.90 21.70L156.40 21.70L157.20 30.40L157.60 30.40Q160.20 25.60 163.90 23.05Q167.60 20.50 171.50 20.50L171.50 20.50Q175.00 20.50 177.10 21.50L177.10 21.50L175.10 31.50Q173.80 31.10 172.70 30.90Q171.60 30.70 170.00 30.70L170.00 30.70Q167.10 30.70 163.90 32.95Q160.70 35.20 158.40 40.80L158.40 40.80L158.40 70.80ZM195.70 90.20L184.20 90.20L184.20 21.70L193.70 21.70L194.50 26.90L194.90 26.90Q198.00 24.30 201.80 22.40Q205.60 20.50 209.70 20.50L209.70 20.50Q214.30 20.50 217.85 22.25Q221.40 24.00 223.90 27.30Q226.40 30.60 227.70 35.20Q229.00 39.80 229.00 45.50L229.00 45.50Q229.00 51.80 227.25 56.75Q225.50 61.70 222.60 65.05Q219.70 68.40 215.90 70.20Q212.10 72 208.00 72L208.00 72Q204.80 72 201.60 70.60Q198.40 69.20 195.40 66.60L195.40 66.60L195.70 74.80L195.70 90.20ZM205.60 62.50L205.60 62.50Q210.50 62.50 213.80 58.25Q217.10 54 217.10 45.60L217.10 45.60Q217.10 38.20 214.60 34.10Q212.10 30.00 206.50 30.00L206.50 30.00Q201.30 30.00 195.70 35.50L195.70 35.50L195.70 58.40Q198.40 60.70 200.90 61.60Q203.40 62.50 205.60 62.50ZM243.30 91L243.30 91Q241.30 91 239.80 90.75Q238.30 90.50 236.90 90L236.90 90L239.00 81Q239.70 81.20 240.65 81.45Q241.60 81.70 242.50 81.70L242.50 81.70Q246.40 81.70 248.75 79.35Q251.10 77 252.30 73.30L252.30 73.30L253.20 70.20L233.90 21.70L245.60 21.70L254.10 45.80Q255.20 49 256.25 52.55Q257.30 56.10 258.40 59.60L258.40 59.60L258.80 59.60Q259.70 56.20 260.65 52.65Q261.60 49.10 262.50 45.80L262.50 45.80L269.90 21.70L281.00 21.70L263.20 73Q261.70 77.20 259.90 80.50Q258.10 83.80 255.75 86.15Q253.40 88.50 250.35 89.75Q247.30 91 243.30 91Z"
                })
            })
        ]
    });
}
function LogoBadge(param) {
    let { showBadge  } = param;
    const [badge, setBadge] = react__WEBPACK_IMPORTED_MODULE_1__.useState("");
    react__WEBPACK_IMPORTED_MODULE_1__.useEffect(()=>{
        const host = (0,_chirpy_dev_utils__WEBPACK_IMPORTED_MODULE_4__/* .getHostEnv */ .qn)();
        if ([
            "staging",
            "preview",
            "localhost"
        ].includes(host)) {
            setBadge(host);
        } else if (host === "prod") {
            setBadge("Beta");
        }
    }, []);
    const useBlueBg = badge !== "Beta";
    if (!showBadge || !badge) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_badge__WEBPACK_IMPORTED_MODULE_5__/* .Badge */ .C, {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("absolute -right-2 -top-3 leading-none", useBlueBg && "-right-3"),
        ...useBlueBg && {
            variant: "solid",
            color: "blue"
        },
        children: badge
    });
}


/***/ }),

/***/ 13570:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ MenuItemPadding; },
/* harmony export */   "v": function() { return /* binding */ Menu; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6769);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14517);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(67765);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(62239);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var _styles_common__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(60677);
/* harmony import */ var _animation__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(93383);
/* harmony import */ var _box__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(2139);
/* harmony import */ var _button__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(49898);
/* harmony import */ var _button__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(44623);
/* harmony import */ var _divider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45565);
/* harmony import */ var _icons__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(18987);











const ERROR = new Error("Menu children only accept a Menu.Items and a Menu.Button");
function Menu(param) {
    let { className , children  } = param;
    const childrenArray = react__WEBPACK_IMPORTED_MODULE_1__.Children.toArray(children);
    if (childrenArray.length !== 2) {
        throw ERROR;
    }
    const items = childrenArray.find((element)=>element.type === MenuItems);
    const button = childrenArray.find((element)=>element.type === MenuButton);
    if (!items || !button) {
        throw ERROR;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("relative inline-block text-left", className),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_3__/* .Menu */ .v, {
            children: (param)=>/*#__PURE__*/ {
                let { open  } = param;
                return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.cloneElement(button, {
                            open
                        }),
                        /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.cloneElement(items, {
                            open
                        })
                    ]
                });
            }
        })
    });
}
Menu.Button = MenuButton;
Menu.Items = MenuItems;
Menu.Item = MenuItem;
Menu.Divider = _divider__WEBPACK_IMPORTED_MODULE_4__/* .Divider */ .i;
function MenuButton(param) {
    let { shape ="circle" , ariaLabel ="click to open the menu" , className , open , onClick , children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_headlessui_react__WEBPACK_IMPORTED_MODULE_3__/* .Menu.Button */ .v.Button, {
            as: shape === "circle" ? _button__WEBPACK_IMPORTED_MODULE_5__/* .IconButton */ .h : _button__WEBPACK_IMPORTED_MODULE_6__/* .Button */ .z,
            "aria-label": ariaLabel,
            onClick: ()=>{
                return onClick === null || onClick === void 0 ? void 0 : onClick(open);
            },
            children: [
                children,
                shape === "square" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icons__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("ml-2 -mr-1 h-5 w-5", open && "rotate-180")
                })
            ]
        })
    });
}
function MenuItems(param) {
    let { children , open , className  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_8__/* .AnimatePresence */ .M, {
        children: open && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_9__.m.div, {
            ..._animation__WEBPACK_IMPORTED_MODULE_10__/* .easeInOut */ .m,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_3__/* .Menu.Items */ .v.Items, {
                static: true,
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("absolute right-0 z-30 mt-1 rounded-md border p-1 shadow-md outline-none", _styles_common__WEBPACK_IMPORTED_MODULE_11__/* .bluredBg */ .a4, className),
                children: children
            })
        })
    });
}
function MenuItem(param) {
    let { as , children , disableAutoDismiss , onClick , className , ...asProps } = param;
    const child = disableAutoDismiss ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        onClick: (e)=>disableAutoDismiss && e.stopPropagation(),
        children: children
    }) : children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_3__/* .Menu.Item */ .v.Item, {
        children: ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_box__WEBPACK_IMPORTED_MODULE_12__/* .Box */ .x, {
                as: as,
                onClick: onClick,
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_styles_common__WEBPACK_IMPORTED_MODULE_11__/* .listHoverable */ .D6, itemStyle, !disableAutoDismiss && MenuItemPadding, className),
                ...asProps,
                children: child
            })
    });
}
const MenuItemPadding = "px-6 py-2";
const itemStyle = "transition flex flex-row items-center border-none text-gray-1200 cursor-pointer w-full text-sm text-right";


/***/ }),

/***/ 55575:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ siteTheme; }
/* harmony export */ });
/* unused harmony export getColors */
/* harmony import */ var _radix_ui_colors__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4295);
/* harmony import */ var _utilities__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40335);


const siteColors = getColors();
const siteTheme = {
    colors: siteColors
};
function getColors() {
    return {
        light: {
            primary: (0,_utilities__WEBPACK_IMPORTED_MODULE_0__/* .translateRadixColor */ .W)(_radix_ui_colors__WEBPACK_IMPORTED_MODULE_1__/* .violet */ .ht),
            plum: (0,_utilities__WEBPACK_IMPORTED_MODULE_0__/* .translateRadixColor */ .W)(_radix_ui_colors__WEBPACK_IMPORTED_MODULE_1__/* .plum */ .vd),
            gray: {
                0: "hsl(0, 0%, 100%)",
                ...(0,_utilities__WEBPACK_IMPORTED_MODULE_0__/* .translateRadixColor */ .W)(_radix_ui_colors__WEBPACK_IMPORTED_MODULE_1__/* .gray */ .MA)
            },
            blue: (0,_utilities__WEBPACK_IMPORTED_MODULE_0__/* .translateRadixColor */ .W)(_radix_ui_colors__WEBPACK_IMPORTED_MODULE_1__/* .blue */ .iN),
            indigo: (0,_utilities__WEBPACK_IMPORTED_MODULE_0__/* .translateRadixColor */ .W)(_radix_ui_colors__WEBPACK_IMPORTED_MODULE_1__/* .indigo */ .QN),
            green: (0,_utilities__WEBPACK_IMPORTED_MODULE_0__/* .translateRadixColor */ .W)(_radix_ui_colors__WEBPACK_IMPORTED_MODULE_1__/* .green */ .ek),
            violet: (0,_utilities__WEBPACK_IMPORTED_MODULE_0__/* .translateRadixColor */ .W)(_radix_ui_colors__WEBPACK_IMPORTED_MODULE_1__/* .violet */ .ht),
            yellow: (0,_utilities__WEBPACK_IMPORTED_MODULE_0__/* .translateRadixColor */ .W)(_radix_ui_colors__WEBPACK_IMPORTED_MODULE_1__/* .yellow */ .er),
            orange: (0,_utilities__WEBPACK_IMPORTED_MODULE_0__/* .translateRadixColor */ .W)(_radix_ui_colors__WEBPACK_IMPORTED_MODULE_1__/* .orange */ .$y),
            red: (0,_utilities__WEBPACK_IMPORTED_MODULE_0__/* .translateRadixColor */ .W)(_radix_ui_colors__WEBPACK_IMPORTED_MODULE_1__/* .red */ .Q6),
            pink: (0,_utilities__WEBPACK_IMPORTED_MODULE_0__/* .translateRadixColor */ .W)(_radix_ui_colors__WEBPACK_IMPORTED_MODULE_1__/* .pink */ .iQ),
            bg: "hsl(210, 20%, 98%)"
        },
        dark: {
            primary: (0,_utilities__WEBPACK_IMPORTED_MODULE_0__/* .translateRadixColor */ .W)(_radix_ui_colors__WEBPACK_IMPORTED_MODULE_1__/* .violetDark */ .Gz),
            plum: (0,_utilities__WEBPACK_IMPORTED_MODULE_0__/* .translateRadixColor */ .W)(_radix_ui_colors__WEBPACK_IMPORTED_MODULE_1__/* .plumDark */ .ib),
            gray: {
                0: _radix_ui_colors__WEBPACK_IMPORTED_MODULE_1__/* .grayDark.gray2 */ .hU.gray2,
                ...(0,_utilities__WEBPACK_IMPORTED_MODULE_0__/* .translateRadixColor */ .W)(_radix_ui_colors__WEBPACK_IMPORTED_MODULE_1__/* .mauveDark */ .XD)
            },
            blue: (0,_utilities__WEBPACK_IMPORTED_MODULE_0__/* .translateRadixColor */ .W)(_radix_ui_colors__WEBPACK_IMPORTED_MODULE_1__/* .blueDark */ .qn),
            indigo: (0,_utilities__WEBPACK_IMPORTED_MODULE_0__/* .translateRadixColor */ .W)(_radix_ui_colors__WEBPACK_IMPORTED_MODULE_1__/* .indigoDark */ .og),
            green: (0,_utilities__WEBPACK_IMPORTED_MODULE_0__/* .translateRadixColor */ .W)(_radix_ui_colors__WEBPACK_IMPORTED_MODULE_1__/* .greenDark */ .u7),
            violet: (0,_utilities__WEBPACK_IMPORTED_MODULE_0__/* .translateRadixColor */ .W)(_radix_ui_colors__WEBPACK_IMPORTED_MODULE_1__/* .violetDark */ .Gz),
            yellow: (0,_utilities__WEBPACK_IMPORTED_MODULE_0__/* .translateRadixColor */ .W)(_radix_ui_colors__WEBPACK_IMPORTED_MODULE_1__/* .yellowDark */ .f3),
            orange: (0,_utilities__WEBPACK_IMPORTED_MODULE_0__/* .translateRadixColor */ .W)(_radix_ui_colors__WEBPACK_IMPORTED_MODULE_1__/* .orangeDark */ .CL),
            red: (0,_utilities__WEBPACK_IMPORTED_MODULE_0__/* .translateRadixColor */ .W)(_radix_ui_colors__WEBPACK_IMPORTED_MODULE_1__/* .redDark */ .nA),
            pink: (0,_utilities__WEBPACK_IMPORTED_MODULE_0__/* .translateRadixColor */ .W)(_radix_ui_colors__WEBPACK_IMPORTED_MODULE_1__/* .pinkDark */ .KV),
            bg: _radix_ui_colors__WEBPACK_IMPORTED_MODULE_1__/* .slateDark.slate1 */ .L0.slate1
        }
    };
}


/***/ }),

/***/ 4201:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ useThemeVariables; }
/* harmony export */ });
/* harmony import */ var _radix_ui_colors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4295);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52983);
/* harmony import */ var _site_theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55575);
/* harmony import */ var _utilities__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40335);




const siteColors = _site_theme__WEBPACK_IMPORTED_MODULE_1__/* .siteTheme.colors */ .n.colors;
const FIXED_COLORS = {
    whitea: (0,_utilities__WEBPACK_IMPORTED_MODULE_2__/* .translateRadixColor */ .W)(_radix_ui_colors__WEBPACK_IMPORTED_MODULE_3__/* .whiteA */ .F9),
    blacka: (0,_utilities__WEBPACK_IMPORTED_MODULE_2__/* .translateRadixColor */ .W)(_radix_ui_colors__WEBPACK_IMPORTED_MODULE_3__/* .blackA */ .U2)
};
function useThemeVariables(theme, selectors) {
    const { light , dark  } = {
        light: ":root",
        dark: ":root.dark",
        ...selectors
    };
    const styles = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(()=>{
        const lightTheme = {
            colors: {
                ...FIXED_COLORS,
                ...siteColors.light,
                ...theme === null || theme === void 0 ? void 0 : theme.colors.light
            }
        };
        const darkTheme = {
            colors: {
                ...siteColors.dark,
                ...theme === null || theme === void 0 ? void 0 : theme.colors.dark
            }
        };
        return "".concat(light, ", ::before, ::after {\n        ").concat((0,_utilities__WEBPACK_IMPORTED_MODULE_2__/* .getThemeCSSVariablesString */ .x)(lightTheme), "\n      }\n\n       ").concat(dark, ", .dark ::before, .dark ::after {\n        ").concat((0,_utilities__WEBPACK_IMPORTED_MODULE_2__/* .getThemeCSSVariablesString */ .x)(darkTheme), "\n      }\n    ");
    }, [
        theme,
        light,
        dark
    ]);
    return {
        styles
    };
}


/***/ }),

/***/ 40335:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ translateRadixColor; },
/* harmony export */   "x": function() { return /* binding */ getThemeCSSVariablesString; }
/* harmony export */ });
function getThemeCSSVariablesString(theme) {
    return getThemeCSSVariables(theme).map((param)=>{
        let [key, value] = param;
        return "".concat(key, ": ").concat(value, ";");
    }).join("\n");
}
/**
 * Support any depth level of nesting objects
 */ function getThemeCSSVariables(theme) {
    let prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "--tw";
    const cssVariables = [];
    for (const [key, value] of Object.entries(theme)){
        const cssVariableKey = prefix && key ? [
            prefix,
            key
        ].join("-") : prefix || key;
        if (typeof value === "string") {
            cssVariables.push([
                cssVariableKey,
                translateColor(value)
            ]);
        } else if (typeof value === "object" && value) {
            cssVariables.push(...getThemeCSSVariables(value, cssVariableKey));
        } else {
            throw new Error("Unexpected theme value: ".concat(value));
        }
    }
    return cssVariables;
}
/**
 * Unwrap hsl color to numbers, e.g. hsl(252 56.0% 57.5%) -> 252deg 56.0% 57.5%
 * Used by css variables
 * @param color
 */ function translateColor(color) {
    const [, hsl] = /hsl\((.+)\)/.exec(color) || [];
    if (hsl) {
        return hsl.replace(/,/g, "");
    }
    const [, hsla] = /hsla\((.+)\)/.exec(color) || [];
    // legacy color format, e.g. hsla(252, 56.0%, 57.5%, 0.75)
    return hsla;
}
/**
 * Get number to color map without key, for example
 * ```js
 * getColorMap({ red1: 'hsl(359, 100%, 99.4%)', }) == {
 * 1: 'hsl(359, 100%, 99.4%)',}
 * ```
 * @param color
 * @returns
 */ function translateRadixColor(color) {
    const result = {};
    for (const [key, value] of Object.entries(color)){
        const [, num] = /\w(\d+)/.exec(key) || [];
        result[100 * +num] = value;
    }
    return result;
}


/***/ }),

/***/ 14273:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ useEventListener; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52983);
/* harmony import */ var _utilities_logger__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29620);


function useEventListener(eventName, listener, element) {
    const listenerRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef();
    listenerRef.current = listener;
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(()=>{
        const targetElement = (element === null || element === void 0 ? void 0 : element.current) || element || window;
        if (!targetElement.addEventListener) {
            _utilities_logger__WEBPACK_IMPORTED_MODULE_1__/* .logger.warn */ .k.warn("Can't find add event listner(".concat(listenerRef.current, ") for element ").concat(element));
            return;
        }
        const eventListener = (event)=>{
            var ref;
            return (ref = listenerRef.current) === null || ref === void 0 ? void 0 : ref.call(element, event);
        };
        targetElement.addEventListener(eventName, eventListener);
        return ()=>{
            targetElement.removeEventListener(eventName, eventListener);
        };
    }, [
        eventName,
        element
    ]);
}



/***/ }),

/***/ 98880:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ useSignInWindow; }
/* harmony export */ });
/* harmony import */ var _chirpy_dev_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49595);
/* harmony import */ var next_auth_react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(60697);
/* harmony import */ var next_auth_react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_auth_react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var _use_event_listener__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14273);




function useSignInWindow() {
    let { width =480 , height =760  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const popupWindow = react__WEBPACK_IMPORTED_MODULE_1__.useRef(null);
    const handleClickSignIn = ()=>{
        popupWindow.current = popupCenterWindow("/auth/sign-in?allowAnonymous=true", "_blank", width, height);
    };
    (0,_use_event_listener__WEBPACK_IMPORTED_MODULE_2__/* .useEventListener */ .O)("storage", async (event)=>{
        if (event.key === _chirpy_dev_utils__WEBPACK_IMPORTED_MODULE_3__/* .SIGN_IN_SUCCESS_KEY */ .CZ && event.newValue === "true") {
            var ref;
            (ref = popupWindow.current) === null || ref === void 0 ? void 0 : ref.close();
            popupWindow.current = null;
            // Force to refresh session
            await (0,next_auth_react__WEBPACK_IMPORTED_MODULE_0__.getSession)();
        }
    });
    return handleClickSignIn;
}
function popupCenterWindow(url, title, width, height) {
    const { userAgent  } = navigator;
    const isMobile = /\b(iPhone|iP[ao]d)/.test(userAgent) || /\b(iP[ao]d)/.test(userAgent) || /android/i.test(userAgent) || /mobile/i.test(userAgent);
    const screenX = window.screenX || window.screenLeft;
    const screenY = window.screenY || window.screenTop;
    const outerWidth = window.outerWidth || document.documentElement.clientWidth;
    const outerHeight = window.outerHeight || document.documentElement.clientHeight - 22;
    const targetWidth = isMobile ? 0 : width;
    const targetHeight = isMobile ? 0 : height;
    const V = screenX < 0 ? window.screen.width + screenX : screenX;
    const left = V + (outerWidth - targetWidth) / 2;
    const right = screenY + (outerHeight - targetHeight) / 2.5;
    const features = [];
    if (targetWidth !== 0) {
        features.push("width=" + targetWidth);
    }
    if (targetHeight !== 0) {
        features.push("height=" + targetHeight);
    }
    features.push("left=" + left, "top=" + right, "scrollbars=1");
    const newWindow = window.open(url, title, features.join(","));
    newWindow === null || newWindow === void 0 ? void 0 : newWindow.focus();
    return newWindow;
}


/***/ }),

/***/ 92388:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ cpDayjs; }
/* harmony export */ });
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35708);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var dayjs_plugin_relativeTime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79201);
/* harmony import */ var dayjs_plugin_relativeTime__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_relativeTime__WEBPACK_IMPORTED_MODULE_1__);


dayjs__WEBPACK_IMPORTED_MODULE_0___default().extend((dayjs_plugin_relativeTime__WEBPACK_IMPORTED_MODULE_1___default()));
// eslint-disable-next-line unicorn/prefer-export-from
const cpDayjs = (dayjs__WEBPACK_IMPORTED_MODULE_0___default());


/***/ }),

/***/ 15392:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"divider":"divider_divider__lzWvE"};

/***/ })

}]);